/**
 * Logger conditionnel qui affiche les logs uniquement en développement
 * Utilisation: import { logger } from '@/utils/logger'
 *
 * En production, tous les logs sont désactivés pour:
 * - Éviter l'exposition de données sensibles
 * - Améliorer les performances
 * - Réduire la taille des logs côté client
 */

class Logger {
  private get isDevelopment(): boolean {
    return process.env.REACT_APP_ENV !== 'production' &&
           process.env.NODE_ENV !== 'production';
  }

  /**
   * Log général (équivalent console.log)
   */
  log(...args: any[]): void {
    if (this.isDevelopment) {
      console.log(...args);
    }
  }

  /**
   * Log d'information
   */
  info(...args: any[]): void {
    if (this.isDevelopment) {
      console.info(...args);
    }
  }

  /**
   * Log d'avertissement (toujours affiché même en prod)
   */
  warn(...args: any[]): void {
    console.warn(...args);
  }

  /**
   * Log d'erreur (toujours affiché même en prod)
   */
  error(...args: any[]): void {
    console.error(...args);
  }

  /**
   * Log de debug (uniquement en dev)
   */
  debug(...args: any[]): void {
    if (this.isDevelopment) {
      console.debug(...args);
    }
  }

  /**
   * Log de table (uniquement en dev)
   */
  table(data: any): void {
    if (this.isDevelopment) {
      console.table(data);
    }
  }

  /**
   * Groupe de logs (uniquement en dev)
   */
  group(label: string): void {
    if (this.isDevelopment) {
      console.group(label);
    }
  }

  groupEnd(): void {
    if (this.isDevelopment) {
      console.groupEnd();
    }
  }
}

export const logger = new Logger();

// Export par défaut pour import simplifié
export default logger;